export default __webpack_public_path__ + "static/media/like-block-img.32ff46c7.png";